import { EMPTY_DISPLAY, LOCATION_COORD_DECIMALS } from '../constants/vendor'

export function formatCurrency(amount: number, currency = 'INR'): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return ''
  return new Intl.DateTimeFormat('en-IN', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso))
}

export function formatRelativeTime(iso: string): string {
  const deltaMs = Date.now() - new Date(iso).getTime()
  const minutes = Math.max(0, Math.round(deltaMs / 60_000))
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  return `${days}d ago`
}

export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}

export function formatCoordinates(latitude: number, longitude: number): string {
  return `${latitude.toFixed(LOCATION_COORD_DECIMALS)}, ${longitude.toFixed(LOCATION_COORD_DECIMALS)}`
}

export function displayAddress(address: string | null): string {
  return address || EMPTY_DISPLAY
}
